<template>
  <v-container>
    <v-toolbar color="elevation-0">
    <v-btn
        icon
    @click="closeView">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>

    <v-toolbar-title>{{$vuetify.lang.t('$vuetify.checklist_components.checklist_detail_component.toolbar.title')}} {{selectedChecklistName}}</v-toolbar-title>

    <v-spacer></v-spacer>


    </v-toolbar>

    <getting-data-overlay :is_loading="is_loading"
                          :loading_display_title="$vuetify.lang.t('$vuetify.checklist.getting_data_title')"></getting-data-overlay>
    <v-row v-if="!is_loading && !has_loading_error">
      <v-col cols="12">
        <p class="text-center" style="color: #666 !important;font-style: italic;" >{{$vuetify.lang.t('$vuetify.checklist_components.checklist_detail_component.warning_message')}}</p>
        <list-view :checklistItems="checklistItems"></list-view>
      </v-col>
    </v-row>
    <v-row v-if="has_loading_error">
      <v-col cols="12">
        <v-col cols="12" class="subtitle-1 text-center">
          {{ $vuetify.lang.t('$vuetify.errors.checklistNotLoaded') }}
        </v-col>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import resourcesApi from "@/api/resources/resourcesApi";
import GettingDataOverlayComponent
  from "@/components/modules/global/gettingDataOverlayComponent/GettingDataOverlayComponent";
import ChecklistListViewComponent from "@/components/modules/checklist/ChecklistListViewComponent";

export default {

  name: "ChecklistDetailComponent",
  data: () => {
    return {
      is_loading: false,
      has_loading_error: false,
      checklistItems: []
    }
  },
  components: {
    gettingDataOverlay: GettingDataOverlayComponent,
    listView : ChecklistListViewComponent
  },
  props: {
    selectedChecklistId: {
      type: Number,
      required: true
    },
    selectedChecklistName: {
      type: String,
      required: true
    }
  },
  methods: {
    closeView() {
      this.$emit('detailClosed')
    },
    getChecklistDetails(){
      this.is_loading = true;

      resourcesApi.getChecklist(this.selectedChecklistId).then((response) => {
        this.is_loading = false;
        this.checklistItems = response.data.checklist_items
      }).catch(
          (error) => {
            this.is_loading = false;
            this.has_loading_error = true;
            window.console.error(error);
          }
      )
    }
  },
  async mounted() {
    //window.console.log('MOUNTED THE DETAIL');
    this.getChecklistDetails();
  },
  destroyed() {
    //window.console.log('Destroyed THE DETAIL')
  }

}
</script>

<style scoped>
.checklist-item {
  padding: 20px;
  min-height: 60px;
}
</style>